import { gql } from 'glimmer-apollo';

export const STREAMERS_QUERY = gql`
  query ($gameSlug: String) {
    streamers: streamerCollection(
      where: { games: { slug: $gameSlug } }
      limit: 20
      order: [isLive_DESC, followers_DESC]
    ) {
      items {
        displayName
        slug
        avatar {
          url
        }
        isLive
        followers
        twitchHandle
        youtubeHandle
        bio
        favouriteGames: gamesCollection(limit: 3) {
          items {
            title
            slug
            coverImage {
              url
            }
          }
        }
      }
    }
  }
`;
